module.exports = __webpack_public_path__ + "static/media/cloudy.14834370.png";